<template>
	<v-dialog v-model="open" width="600" persistent>
		<v-card class="background-2 round-card">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Importa Ordini da File</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pa-0">
				<v-container>
					<v-row class="pb-3 px-2 pt-4">
						<v-col class="px-4 py-0" cols="12">
							<v-select
								v-model="type"
								:items="types"
								item-text="text"
								item-value="value"
								:menu-props="{'offset-y': true}"
								outlined dense
								label="Tipo di import">
							</v-select>
						</v-col>

						<v-col class="px-4 py-0" cols="12" v-if="type === 'standard'">
							<v-btn text color="info" class="mb-3 px-0" @click.native="downloadTemplate()">
								<v-icon left>mdi-download-outline</v-icon>modello CSV
							</v-btn>
						</v-col>

						<v-col class="px-4 py-0" cols="12">
							<v-file-input
								v-model="file"
								outlined dense
								accept=".csv"
								small-chips
								hide-details
								label="File">
							</v-file-input>
						</v-col>

						<v-col class="px-4 pt-4 pb-0" cols="12">
							<v-alert type="info" text dense class="mb-0">{{ hint }}</v-alert>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="red" @click="close()">chiudi</v-btn>
				<v-btn text color="primary" :disabled="!file" :loading="loading" @click="uploadFile()">importa</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

	export default {
		name: 'import-purchaseorders-dialog',
		props: {
			open: Boolean,
			params: Object,
			button: Object,
			selected: Array,
			modelDef: String,
			selectedIds: Array,
		},

		data() {
			return {
				loading: false,
				file: null,
				type: 'sonepar',
				types: [
					{value: 'mef', text: 'MEF'},
					{value: 'sonepar', text: 'SONEPAR'},
					{value: 'standard', text: 'Standard'},
				],
			}
		},

		computed: {
			hint() {
				if (this.type === 'standard') {
					return 'Scarica il modello CSV e compilalo: un file può contenere più ordini, raggruppati per numero ordine.'
				}
				if (this.type === 'mef') {
					return 'Il tracciato MEF è in fase di definizione: l\'import non è ancora operativo.'
				}
				return 'Carica il file ordini del fornitore: può contenere più ordini. L\'elaborazione avviene in background.'
			},
		},

		methods: {

			downloadTemplate() {
				this.$eventBusUtility.openFile(this.$store, '/purchaseorders-downloadcsv/', 'ordini_acquisto.csv')
			},

			close() {
				this.file = null
				this.loading = false
				this.$emit('close')
			},

			uploadFile() {
				if (!this.file) {
					return false
				}

				this.loading = true

				var formData = new FormData()
				formData.append('file', this.file)
				formData.append('type', this.type)

				this.axios.post('purchaseorders-uploadcsv/',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
							'Accept': 'application/json'
						}
					}).then(response => {
						let data = response.data
						let snackmessage = 'Import avviato: riceverai una notifica al termine'
						let snackcolor = 'success'

						if (data.status !== 'success') {
							snackmessage = data.message
							snackcolor = 'warning'
						}

						this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
						this.close()

					}, response => {
						this.loading = false
					})
			},
		}
	}
</script>
